import { useIsDesktopTargetSelectorEnabled } from '@/features/flags/desktop-target-selector-flag';
import type { RoutineComputerList } from '@heidi/agents';

import { routineComputerChoices } from './desktopTargetSelection';
import { useNativeInstanceId } from './nativeInstanceId';
import { useDesktopTargetRoster } from './useDesktopTargetRoster';

/**
 * Choices for the routine "Preferred computer" dropdown, behind the same flag
 * and roster as the Run by picker. `enabled` gates the whole Computer use section.
 * The roster only loads while the picker is shown, so hidden pickers do not poll.
 */
export function useRoutineComputerChoices(pickerVisible: boolean): {
  enabled: boolean;
  computers: RoutineComputerList;
  thisComputerId: string | null;
} {
  const enabled = useIsDesktopTargetSelectorEnabled();
  const loadRoster = enabled && pickerVisible;
  const roster = useDesktopTargetRoster(loadRoster);
  const instance = useNativeInstanceId(loadRoster);

  if (!roster.data) {
    return { enabled, computers: { status: 'loading' }, thisComputerId: null };
  }
  const { machines, thisComputerId } = routineComputerChoices(
    roster.data.targets,
    instance.data ?? null
  );
  return { enabled, computers: { status: 'ready', machines }, thisComputerId };
}
